import GradientProgressBar from './GradientProgressBar';
import React, { memo, useMemo, useState } from 'react';
import getAnimationPresets from '../utils/getAnimationPresets';
import useTimerInterval from '../../../hooks/useTimerInterval';
import useEffectOnce from '../../../hooks/useEffectOnce';
import useToggleState from '../../../hooks/useToggleState';
import { useSelector } from 'react-redux';
import { getFreeOrdersLeftSelector, getOrdersLimitSelector } from '../demoLimitsSelectors';

function GradientProgressBarAnimated() {
    const [isAnimationProgress, , , offAnimationProgress] = useToggleState(true);
    const ordersLimit = useSelector(getOrdersLimitSelector);
    const freeOrdersLeft = useSelector(getFreeOrdersLeftSelector);
    const animationPresets = useMemo(() => getAnimationPresets(ordersLimit), [ordersLimit]);
    const [animationPresetIndex, setAnimationPresetIndex] = useState(0);
    const { startTimer: startAnimation } = useTimerInterval({
        callback: () => setAnimationPresetIndex(index => index + 1),
        isContinueInterval: animationPresetIndex < animationPresets.length - 1,
        onTimerEnd: offAnimationProgress,
        timeout: 70,
    });
    const { direction, activeCount } = animationPresets[animationPresetIndex];

    useEffectOnce(() => {
        startAnimation();
    });

    return <GradientProgressBar count={ordersLimit} activeCount={isAnimationProgress ? activeCount : freeOrdersLeft}
                                direction={direction}
                                messageCount={isAnimationProgress ? ordersLimit : freeOrdersLeft}/>;
}

export default memo(GradientProgressBarAnimated);
